import React, { Component } from 'react'

import Layout from '../../components/Layout'
import CrudHeader from '../../components/CrudHeader'
import UserToolbar from '../../components/UserToolbar'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { profilesActions, searchTableActions } from '../../actions'
import { crudListStyle } from '../../styles'

class Profiles extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  componentWillMount() {
    const { fetchFunctionalities } = this.props
    fetchFunctionalities()
  }

  render() {
    const { modalOpen, openModal, closeModal, newProfile, classes, token } = this.props

    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Perfis'}
          classes={classes}
          newResource={newProfile}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'perfis'}
        />
        <ListTable />
        <EditModal open={modalOpen} onClose={closeModal} />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.profiles.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(profilesActions.openModal())
    },
    closeModal: () => {
      dispatch(profilesActions.closeModal())
    },
    newProfile: profile => {
      dispatch(profilesActions.newFormProfile(profile))
    },
    resetState: () => {
      dispatch(profilesActions.resetState())
    },
    fetchFunctionalities: () => {
      dispatch(profilesActions.fetchFunctionalities())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Profiles))



// WEBPACK FOOTER //
// ./src/containers/Profiles/index.js